import { FormGroup, FormBuilder } from '@angular/forms';
import { FormSec002Build } from './forms-build/form-sec002-build';

export class FormSec002 extends FormSec002Build {
    public CreateForm(formBuilder: FormBuilder): FormGroup {
        const formulario: FormGroup = formBuilder.group({
            id: [0, []],
            site_recebimento: ['', []],
            site_origem: ['', []],
            safra: ['', []],
            safra_basica: ['', []],
            controle_secagem: ['', []],
            secador_camara: ['', []],
            tipo_colheita: ['', []],
            contrato_campo: ['', []],
            contrato_campo_2: ['', []],
            n_de_campo_basica: ['', []],
            hibrido_rnc_linhagem: ['', []],
            geracao_basica: ['', []],
            especie_basica: ['', []],
            inicio_enchimento: ['', []],
            termino_enchimento: ['', []],
            peso_rw_kg_total: ['', []],
            altura_camada_m: ['', []],
            umidade_media_cerar: ['', []],
            cerar_basica: ['', []],
            //justificativa_camara: ['', []],
            inicio_secagem: ['', []],
            inversao_camara: ['', []],
            termino_secagem: ['', []],
            umidade_media_de_fechamento_avm: ['', []],
            umidade_topo_de_fechamento_moff: ['', []],
            ressecagem: ['', []],
            inicio_ressecagem: ['', []],
            termino_ressecagem: ['', []],
            inicio_debulha: ['', []],
            termino_debulha: ['', []],
            motivo_espera_debulha: ['', []],
            umidade_minima: ['', []],
            umidade_maxima: ['', []],
            umidade_debulha_media: ['', []],
            desvio_padrao: ['', []],
            peneira_topo_utilizada: ['', []],
            retido_na_peneira_topo: ['', []],
            peneira_fundo_utilizada: ['', []],
            vazado_na_peneira_fundo: ['', []],
            linha_da_debulha: ['', []],
            enchimento_horas_atividade_1010: ['', []],
            primeiro_ciclo_horas: ['', []],
            segundo_ciclo_horas: ['', []],
            ressecagem_horas: ['', []],
            secagem_horas_atividade_2010: ['', []],
            espera_horas: ['', []],
            debulha_horas_atividade_3010: ['', []],
            // peso_debulha_kg: ['', []],
            // lote_ds: ['', []],
            // silo_destino: ['', []],
            status_silo: ['', []],
            ordem_ds: ['', []],
            peso_debulha_kg_total: ['', []],
            volume_calda_litros: ['', []],
            calda_por_tonelada_l_ton: ['', []],
            concentracao_k_obiol: ['', []],
            concentracao_actellic: ['', []],
            k_obiol_litros: ['', []],
            actellic_litros: ['', []],
            check_sap_rw: ['', []],
            check_sap_ds: ['', []],
            check_sap_quimicos: ['', []],
            inicio_da_transilagem: ['', []],
            silo_destino_transilagem: ['', []],
            motivo: ['', []],
            inicio_da_retirada_para_armazem: ['', []],
            inicio_da_retorno_silo: ['', []],
            silo_de_destino_retorno: ['', []],
            local_atual: ['', []],
            inicio_descarga_silo: ['', []],
            destino_ds_final: ['', []],
            armazenagem_dias: ['', []],
            created_by: ['', []],
            observacao: ['', []],
            faixa_azul_campo: ['', []],
            faixa_azul_umidade_de_colheita: ['', []],
            faixa_azul_temperatura_de_secagem: ['', []],
            faixa_azul_sem_vapor_ou_ventilacao: ['', []],
            faixa_azul_ressecagem: ['', []],
            faixa_azul_transbordo: ['', []],
            faixa_azul_claro_temperatura_carga: ['', []],
            faixa_azul_claro_tempo_de_patio: ['', []],
            faixa_azul_escuro_temperatura_carga: ['', []],
            faixa_azul_escuro_tempo_de_patio: ['', []],
            faixa_azul_escuro_granel_tempo_de_transporte: ['', []],
            faixa_vermelha: ['', []],
            faixa_roxa: ['', []],
            // faixa_marrom: ['', []],
            faixa_laranja: ['', []],
            faixa_cinza: ['', []],
            offline: true,
            list_sdc: ['', []],
            list_loteds: ['', []],
            gleba: ['', []],
            numero_caixa: ['', []],
            umidade_recebimento: ['', []],
            cooperante: ['', []],
            secagem_horas: ['', []],
            faixa_azul_tempo_de_patio: ['', []],
            responsavel: ['', []],
            tempo_de_patio: ['', []],
            list_secagem: ['', []],
            lote_rw: ['', []],
            controle_caixa: ['', []],
            houve_troca_caixa: ['', []],
            numero_novo_caixa: ['', []],
            nota_ardida: ['', []],
            origem_negocio: ['', []],
            optek_amostra: ['', []],
            umidade_amostra: ['', []],
            data_amostragem: ['', []],
            avaliacao_nivelamento: ['', []],
            observacao_nivelamento: ['', []]
        });
        return formulario;
    }
}
